module.exports = __webpack_public_path__ + "img/pointB_gr1_2.7e1a6f9a.png";